import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IGridAction = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <circle
              cx="11"
              cy="11"
              r="10.25"
              stroke="#37474F"
              strokeWidth="1.5"
            />
            <circle cx="5.5" cy="11" r="1.375" fill="#37474F" />
            <circle cx="11" cy="11" r="1.375" fill="#37474F" />
            <circle cx="16.5" cy="11" r="1.375" fill="#37474F" />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IGridAction;
